import React from 'react'

function renderTimeSlots(timeSlots) {
    let options = [];
    timeSlots.forEach((slot)=>{
        slot.picking_times.forEach((pickingTime) => {
            options.push(<option
                    key={`${slot.start_time}-${slot.end_time}-${pickingTime}`}
                    data-time-slot={`${slot.start_time}-${slot.end_time}`}
                    value={pickingTime}>
                    {pickingTime}
                </option>)
        });
    });
    return options;
}

function renderErrors(errors) {
    if (!errors.time_slot) { return false;}

    return errors.time_slot && errors.time_slot.map(function (error, index) {
        return (
          <div key={index}
               className="help-block error">{error}</div>
        )
    });
}


const TakeAwayTimeSlotForm = ({errors, onChange, takeAwaySlots, selectedPickingTime}) => {
    return (
        <div className="delivery-address-form order-step">
            <h4>
                {I18n.t('cart_summary.pickup_time')}
            </h4>
            <fieldset>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <select name="time_slot"
                                    className="form-control"
                                    value={selectedPickingTime || ''}
                                    onChange={(event) => onChange(event)}>
                                <option value="">{I18n.t('cart_summary.select_delivery_time')}</option>
                                {renderTimeSlots(takeAwaySlots)}
                            </select>
                            {renderErrors(errors)}
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    );
};

export default TakeAwayTimeSlotForm;
